import React, { Component } from 'react';
import { firebaseConfig } from './firebase/creds'
import $, { data } from "jquery";
import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue, update, child, get, set, remove } from "firebase/database";
import { getAuth, createUserWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { getStorage, getDownloadURL, listAll } from "firebase/storage";
import "./CSS/styles.css";
import toast, { Toaster } from 'react-hot-toast';
import isEqual from 'lodash.isequal';
import 'react-tabs/style/react-tabs.css';
import 'quill/dist/quill.snow.css';

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth();
var storage = getStorage(app);
// Initialize Realtime Database and get a reference to the service
const database = getDatabase(app);

const api = process.env.REACT_APP_API;
const video_api = process.env.REACT_APP_VIDEO_API;

export class Home extends Component {
  static displayName = Home.name;

  constructor(props) {
    super(props);
    this.state = {
      allProfiles: [],
      profile: '',
      tweets: {},
      currentMonth: '',
    };
  }

  componentDidMount() {
    this.clearStateOnce("hpanelv2");
    this.loadState();
    this.loadProfiles();
    this.loadTweets();
  }

  clearStateOnce = (uid) => {
    var loader = localStorage.getItem('loader') || '';
    if (loader !== uid) {
      localStorage.removeItem('thisState');
      localStorage.setItem('loader', uid);
    }
  }

  loadState = () => {
    const savedState = localStorage.getItem('thisState') || {};
    if (Object.keys(savedState).length === 0) {
      return;
    }
    this.setState(JSON.parse(savedState));
  }

  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(prevState, this.state)) {
      const stateToSave = { ...this.state };

      // delete stateToSave.expandedIndexes;
      localStorage.setItem('thisState', JSON.stringify(stateToSave));
    }
  }



  showAlert = (message, typeClass = 'alert-error') => {
    if (typeClass === 'alert-error') {
      toast.error(message, {
        duration: 4000,
        position: 'top-center',

        // Styling
        style: {},
        className: 'alert-error',

        // Change colors of success/error/loading icon
        iconTheme: {
          primary: 'red',
          secondary: '#fff',
        },

        // Aria
        ariaProps: {
          role: 'status',
          'aria-live': 'polite',
        },
      });
    } else {
      toast.success(message, {
        duration: 4000,
        position: 'top-center',

        // Styling
        style: {},
        className: 'alert-success',

        // Change colors of success/error/loading icon
        iconTheme: {
          primary: 'green',
          secondary: '#fff',
        },

        // Aria
        ariaProps: {
          role: 'status',
          'aria-live': 'polite',
        },
      });
    }
  }

  loadProfiles = () => {
    var userRef = ref(database, 'cmsScholar');
    get(userRef).then((snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        if (data !== null && typeof data !== 'undefined') {
          var papers = [];
          for (var key in data) {
            var paper = data[key];
            papers.push({
              key: key,
              ...paper
            });
          }
          this.setState({ allProfiles: papers });
        } else {
          this.setState({ allProfiles: [] });
        }
      } else {
        // console.log("No data available for this user.");
        this.setState({ allProfiles: [] });
      }
    }).catch((error) => {
      console.error(error);
      this.setState({ allProfiles: [] });
    });
  }

  loadTweets = () => {
    var userRef = ref(database, 'cms_tweets');
    get(userRef).then((snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        if (data !== null && typeof data !== 'undefined') {

          this.setState({ tweets: data });
        } else {
          this.setState({ tweets: {} });
        }
      } else {
        // console.log("No data available for this user.");
        this.setState({ tweets: {} });
      }
    }).catch((error) => {
      console.error(error);
      this.setState({ tweets: {} });
    });
  }

  getPaginatedPaper() {
    const { profile, currentMonth, allProfiles, tweets } = this.state;
    let filteredStudents = tweets;

    var data = filteredStudents[profile][currentMonth] || [];

    var papers = [];
    for (var key in data) {
      var paper = data[key];
      papers.push({
        key: key,
        ...paper
      });
    }

    return papers;
  }

  getMonthName = () => {
    const uniqueMonths = [
      ...new Set(
        Object.values(this.state.tweets).flatMap((user) => Object.keys(user))
      ),
    ];

    return uniqueMonths;
  }

  render() {
    $(document).ready(function () {
    });
    return (
      <div className="website">
        <div className='webSelect container'>
          <select className='webSelect' onChange={(e) => this.setState({ profile: e.target.value })} value={this.state.profile}>
            <option value=''>Select Profile</option>
            {this.state.allProfiles.map((profile) => {
              return <option key={profile.key} value={profile.uid}>{profile.Name}</option>
            })}
          </select>
          <select className='webSelect' onChange={(e) => this.setState({ currentMonth: e.target.value })} value={this.state.currentMonth}>
            <option value=''>Select Month</option>
            {this.getMonthName().map((month) => (
              <option key={month} value={month}>
                {month}
              </option>
            ))}
          </select>
        </div>
        <div className='socialDiver container'>
          {
            this.state.profile && this.state.currentMonth ? (
              this.getPaginatedPaper().map((paper) => {
                return (
                  <div key={paper.key} className="paper">
                    <div className='Copier'>
                      <button className='copyBtn' onClick={() => {
                        var tweet = paper.tweet;
                        tweet = tweet.replace(/<[^>]*>?/gm, '');
                        // tweet is a html make it text
                        tweet = tweet.replace(/&nbsp;/g, ' ');
                        navigator.clipboard.writeText(tweet);
                        alert('Copied to clipboard');
                      }}><i class="fa-solid fa-copy"></i></button>
                    </div>
                    <div className='paperContent'
                      dangerouslySetInnerHTML={{ __html: paper.tweet }}>
                    </div>
                    <hr />
                    <div className='paperDetails'>
                      <div className='paperTitle'>{paper.title}</div>
                      <div className='paperAuthor'>Citations: {paper.citation} | {paper.author}</div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className='WrongChooser'>Please select a profile and a month first.</div>
            )
          }
        </div>
      </div>
    );
  }
} 
